"use strict";
(function () {
    angular
        .module('connections.domainselector', []);
})();

//# sourceMappingURL=connections.domainselector.module.js.map
